'use client';
import { createContext, useContext } from 'react';

function noop() {
  //
}
const RadioContext = createContext({
  isChecked: false,
  check: noop,
  uncheck: noop,
  isFocused: false,
  isDisabled: false
});
const useRadio = () => useContext(RadioContext);

export { RadioContext, useRadio };
//# sourceMappingURL=RadioProvider.js.map
